import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { clearOneTimePaymentValue } from '../../actions/billing/getOneTimePaymentValue';
import { clearChangeResultData } from '../../actions/billing/changeBillingDate';
import { clearBillDate } from '../../actions/billing/selectBillingDate';
import { clearBillingEligibilityData } from '../../actions/billing/getChangeBillingDateEligibility';
import useCurrentOffer from '../../hooks/useCurrentOffer';
import PaymentOrchestrator from '../../components/PaymentOrchestrator';

const ChangeBillingDatePage = ({ isWebview }) => {
  const currentOffer = useCurrentOffer();
  const dispatch = useDispatch();

  useEffect(
    () => () => {
      dispatch(clearChangeResultData());
      dispatch(clearOneTimePaymentValue());
      dispatch(clearBillDate());
      dispatch(clearBillingEligibilityData());
    },
    [dispatch]
  );
  return <PaymentOrchestrator upgradeOffer={currentOffer} isWebview={isWebview} isBillDateChange />;
};

ChangeBillingDatePage.propTypes = {
  isWebview: PropTypes.bool,
};

export default ChangeBillingDatePage;
